import { CanAccess } from 'react-admin';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { type ComponentType, lazy } from 'react';
import { EditGuesser } from 'react-admin';

import { resources } from '@repo/c360-ra-components';

const AsyncPageCreate = lazy(() => import('./create'));
const AsyncPageList = lazy(() => import('./list'));
const AsyncPageShow = lazy(() => import('./show'));
const AsyncPageEdit = lazy(() => import('./edit'));

const protectedList = () => (
  <CanAccess resource={resources.clientUsers} action="list">
    <AsyncPageList />
  </CanAccess>
);

export default {
  list: protectedList as ComponentType<any>,
  edit: AsyncPageEdit as ComponentType<any>,
  show: AsyncPageShow as ComponentType<any>,
  create: AsyncPageCreate as ComponentType<any>,
  icon: AdminPanelSettingsIcon,
};
